import {ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {animate, sequence, style, transition, trigger} from '@angular/animations';

import {filter, Subscription} from 'rxjs';

import {PanelNavigationService} from '@commons/services/navigation/panel-navigation.service';
import {VehicleService} from '@commons/services/vehicle/vehicle.service';
import {Vehicle} from '@commons/models/domain/Vehicle';

import {BaseComponent} from "@shared/components/base-component";
import {NewNavigationService} from "@shared/services/new-navigation.service";
import { MapService } from '@commons/services/map/map/map.service';
import { LOCAL_STORAGEV_CONFIG_VALULE, VehicleListTypeDataVisible } from '../components/configurator-list-vehicle/configurator-list-vehicle.component';
import { VehicleListFilterRequest } from '@commons/models/remote.request/VehicleListFilterRequest';
import { IOnChangedTachoFilters } from '@src/app/interfaces/filters-vehicle.interface';

@Component({
  selector: 'tk-vehicle-panel-lite',
  templateUrl: './vehicle-panel-lite.component.html',
  styleUrls: ['./vehicle-panel-lite.component.less'],
  animations: [
    trigger('openClose', [
      transition(":enter", [style({transform: 'translateX(-264px)'}), animate('0.1s')]),
      transition(":leave", [sequence([style({left: '56px', 'z-index': 0}), animate('0.1s', style({left: '-264px'}))])]),
    ])
  ]
})
export class VehiclePanelLiteComponent extends BaseComponent implements OnInit, OnDestroy {

  isVisible = false;
  vehicles?: Vehicle[];
  etollVehicles?: Vehicle[];
  public tachoVehicles?: Vehicle[];
  selectedVehicleId?: number;
  group: number = 0;
  currentFilter: any;
  isOpen: boolean = false;
  eTollPanelSize = 0;
  public isVisibleConfigForm: boolean;
  public listDataTypeVisible: VehicleListTypeDataVisible;

  public filtersSelectedTachoList: IOnChangedTachoFilters;

  private navSub?: Subscription;
  private vehiclesSub?: Subscription;
  private vehicleFilteredSub?: Subscription;
  private firstRefresh: boolean;
  
  constructor(
    private $nav: PanelNavigationService,
    private $vehicle: VehicleService,
    private $map: MapService,
    private $zone: NgZone,
    private $route: ActivatedRoute,
    private newNavigationService: NewNavigationService,
    private changeDetectorRef: ChangeDetectorRef,
    private renderer2: Renderer2,
  ) {
    super();
    this.subToGetVisibilitySubject();
    this.firstRefresh = true;
  }

  ngOnInit(): void {
    this.initListDataType();
    this.getBlockedStatusVehiclesList();
  }

  private getBlockedStatusVehiclesList(): void {
    this.getVehiclesList();
  }

  private getVehiclesList(): void {
    this.vehiclesSub = this.$vehicle.getListFiltered$()
      .pipe(
        filter(f => this.isVisible === true),
      )
      .subscribe(vehicles => {
        if (this.isVisible === true) {
          this.$zone.run(() => {
            const isTheSame = this.isTheSame(this.vehicles || [], vehicles || []);
            if (!isTheSame) {
              const query = this.$route.snapshot.queryParamMap;
              if (query.get('mode') !== 'details') {
                this.$map.fitMapBoundsToVehicles(vehicles);
              }
            }
            if (this.firstRefresh && vehicles && vehicles.length == 0 && !this.currentFilter) {
              this.vehicles = undefined;
              this.firstRefresh = false;
              this.etollVehicles = undefined;
              this.tachoVehicles = undefined;
            } else {
              this.vehicles = vehicles.sort((a, b) => a.Nm!.localeCompare(b.Nm!));
              this.etollVehicles = vehicles.filter(v => v.ES > 0);
              this.tachoVehicles = vehicles.filter(v => v.TC);
            }
          });
        }
      });
  }

  public onChangeFilters(filters: VehicleListFilterRequest): void {
    this.currentFilter = {...(filters || {})};
  }

  public onChangeTachoFilters(data: IOnChangedTachoFilters): void {
    this.filtersSelectedTachoList = {...data};
  }

  private initListDataType(): void {
    this.listDataTypeVisible = Number(localStorage.getItem(LOCAL_STORAGEV_CONFIG_VALULE) || VehicleListTypeDataVisible.Speed);
  }

  public onSubmitConfigForm(data: VehicleListTypeDataVisible): void {
    this.isVisibleConfigForm = false;
    this.listDataTypeVisible = data;
  }

  private subToGetVisibilitySubject() {
    this.navSub = this.$nav.getVisibilitySubject()
      .pipe(filter(item => (
        !item.subsites
        || item.subsites.indexOf('vehicle-lite') !== -1
        || item.subsites.indexOf('vehicle-details') !== -1
      )))
      .subscribe(change => {
        if (change.id) {
          this.selectedVehicleId = parseInt(change.id, 10);
        } else {
          this.selectedVehicleId = undefined;
        }

        const originalVisibility = this.isVisible;
        this.isVisible = change.show;

        if (originalVisibility && !change.show) {
          this.isOpen = false;
        } else if (!originalVisibility && change.show) {
          this.isOpen = true;
        }

        this.$vehicle.refreshListFiltered();
      });
  }

  private isTheSame(prev: Vehicle[], next: Vehicle[]): boolean {
    prev.sort((x, y) => x.Id! - y.Id!);
    next.sort((x, y) => x.Id! - y.Id!);

    let i = 0;
    let j = 0;
    const joined: Vehicle[] = [];

    while (i < prev.length && j < next.length) {

      if (prev[i].Id === next[j].Id) {
        joined.push(prev[i]);
        i += 1;
        j += 1;
      } else if (prev[i].Id! < next[j].Id!) {
        i += 1;
      } else {
        j += 1;
      }
    }
    const flag = (joined.length === prev.length) && (prev.length === next.length);
    return flag;
  }

  ngOnDestroy(): void {
    if (this.navSub) {
      this.navSub.unsubscribe();
    }
    if (this.vehiclesSub) {
      this.vehiclesSub.unsubscribe();
    }
    if (this.vehicleFilteredSub) {
      this.vehicleFilteredSub.unsubscribe();
    }
    this.unsubscribeAll();
  }

  onEtollExpanded(size: number) {
    this.eTollPanelSize = size;
    this.setHeightForCdkVehicleScroll();
  }

  private get etollPanelHeight(): number {
    const etollInstance = document.getElementById('etoll-balance');
    return etollInstance?.clientHeight || 0;
  }

  private setHeightForCdkVehicleScroll(): void {
    setTimeout(() => {
      const cdkVirtualScroll = document.getElementById('cdk-virtual-scroll-vehicles');
      const cdkScrollHeightCalculate = `calc(100vh - (277px + ${ this.etollPanelHeight }px))`;
      this.renderer2.setStyle(cdkVirtualScroll, 'height', cdkScrollHeightCalculate);
    }, 0);
  }

  onClose() {
    this.newNavigationService.toMainPanel();
  }

  onSelectedIndexChange() {
    this.changeDetectorRef.detectChanges();
    this.setHeightForCdkVehicleScroll();
  }
}
